import { AlertComponent } from '@app/notifications/shared/alert.component';
import { AUSnackBarComponent } from '@app/notifications/snackbars/au-snackbar.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSuffix } from '@angular/material/form-field';
import { NgModule } from '@angular/core';
import { NotificationsComponent } from '@app/notifications/shared/notifications.component';
import { SharedModule } from '@app/shared/shared.module';
import { SnackbarMarkupPipe } from '@app/notifications/snackbars/snackbar-markup.pipe';
import { StopPropagationDirective } from '@app/shared/directives/stop-propagation.directive';
import { ToastComponent } from '@app/notifications/toast/toast.component';

@NgModule({
  declarations: [AlertComponent, AUSnackBarComponent, NotificationsComponent, ToastComponent],
  exports: [AlertComponent, NotificationsComponent, ToastComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    SharedModule,
    SnackbarMarkupPipe,
    StopPropagationDirective,
    MatSuffix
  ],
  providers: []
})
export class NotificationsModule {}
